import { Inject, Injectable } from "@angular/core";
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from "@azure/msal-angular";
import { InteractionStatus, RedirectRequest } from "@azure/msal-browser";
import { AppShellStore } from "../app-shell.store";
import { AuthConfigService } from "./auth-config.service";

@Injectable()
export class AuthService {

    constructor(
        @Inject(MSAL_GUARD_CONFIG) 
        private readonly msalGuardConfig: MsalGuardConfiguration,
        private readonly msalBroadcastService: MsalBroadcastService,
        private readonly msalService: MsalService,
        private readonly authConfigService: AuthConfigService,
        private readonly appShellStore: AppShellStore,
    ) {}

    public initAuthentication() {
        this.msalBroadcastService.inProgress$.subscribe((status) => {
            if (status === InteractionStatus.None) {
                this.checkAndSetActiveAccount();
            }
        });
    }
   
    private checkAndSetActiveAccount() {
        const activeAccount = this.msalService.instance.getActiveAccount();
        if (!activeAccount && this.msalService.instance.getAllAccounts().length > 0) {
            const accounts = this.msalService.instance.getAllAccounts();
            this.msalService.instance.setActiveAccount(accounts[0]);
        }
        if (activeAccount) {
            this.appShellStore.setUser(activeAccount);
        } else {
            this.signIn();
        }
    }
    
    private signIn(): void {
        if (this.msalGuardConfig.authRequest) {
            this.msalService.loginRedirect({ ...this.msalGuardConfig.authRequest } as RedirectRequest);
        } else {
            this.msalService.loginRedirect();
        }
    }

    public signOut(): void {
        const activeAccount = this.msalService.instance.getActiveAccount() || this.msalService.instance.getAllAccounts()[0];
        const config = this.authConfigService.msalConfig;
        this.msalService.logoutRedirect({
            account: activeAccount,
            postLogoutRedirectUri: config.auth.postLogoutRedirectUri,
        });
    }

}
